import { ComponentType, useEffect, useState } from 'react';
import FormInstructionComponent from './FormInstructionComponent';
import TaskInstructionComponent from './TaskInstructionComponent';
import { Box, Button, Card, Stack } from '@mui/material';
import OcInsightsComponent from './OcInsightsComponent';
import PdfInstructionComponent from './PdfInstructionComponent';
import { SelfServiceInstruction } from '../../../api/mutations/selfService/types';
import { useTranslation } from 'react-i18next';

const INSTRUCTION_MAP: Record<string, ComponentType<any>> = {
  form: FormInstructionComponent,
  task: TaskInstructionComponent,
  'oc-insights': OcInsightsComponent,
  pdf: PdfInstructionComponent,
};

export interface SelfServiceInstructionProps<T extends SelfServiceInstruction> {
  instruction: T;
  onReadyStatusChange: (ready: boolean) => void;
  onInstructionChange?: (instruction: T) => void;
}

interface InstructionComponentProps {
  instruction?: SelfServiceInstruction;
  onSubmit: (instruction: SelfServiceInstruction) => void;
  jobsiteId: string;
  sessionId: string;
}

export default function InstructionComponent({
  instruction,
  onSubmit,
  jobsiteId,
  sessionId,
}: InstructionComponentProps) {
  const { t } = useTranslation();

  const [isValid, setIsValid] = useState(false);
  const [instructionData, setInstructionData] = useState<SelfServiceInstruction>();

  useEffect(() => {
    setInstructionData(instruction);
  }, [instruction]);

  if (!instructionData) return <Box>no instruction</Box>;

  const Instruction = INSTRUCTION_MAP[instructionData.component];

  return (
    <Card
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: 2,
        padding: 2,
        justifyContent: 'space-between',
      }}
    >
      <Stack flex={1} sx={{ overflowY: 'auto' }}>
        <Instruction
          instruction={instructionData}
          onReadyStatusChange={setIsValid}
          onInstructionChange={setInstructionData}
          jobsiteId={jobsiteId}
          sessionId={sessionId}
        />
      </Stack>
      {instructionData.component !== 'success' && (
        <Button variant='contained' onClick={() => onSubmit(instructionData)} disabled={!isValid}>
          {t('common.next')}
        </Button>
      )}
    </Card>
  );
}
